/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { SpoofDroneRequest } from "../../../skills/actions/spoof_multi_drone/spoof_multi_drone";
import { TriggerArgs_TimerCallback } from "../../trigger_args";

export const protobufPackage = "complimentary_actions";

export interface SpoofDroneCommand {
  /**
   * How long to spoof the message for. Note that the messages are only published at the timer
   * callback dt, so the actual duration may be slightly longer unless it's an exact multiple of the
   * timer callback dt.
   */
  durationS: number;
  spoofedDrones: SpoofDroneRequest[];
}

export interface SpoofMultiDroneActionArgs {
  trigger:
    | TriggerArgs_TimerCallback
    | undefined;
  /**
   * Each SpoofDroneCommand is published sequentially for the given duration, allowing for
   * simulating drone movement. At the end of the skill, we set the `is_inactive` field to true for
   * all spoofed drones to ensure they stop getting spoofed.
   */
  spoofDroneCommands: SpoofDroneCommand[];
}

function createBaseSpoofDroneCommand(): SpoofDroneCommand {
  return { durationS: 0, spoofedDrones: [] };
}

export const SpoofDroneCommand = {
  encode(message: SpoofDroneCommand, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.durationS !== 0) {
      writer.uint32(13).float(message.durationS);
    }
    for (const v of message.spoofedDrones) {
      SpoofDroneRequest.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofDroneCommand {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofDroneCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.durationS = reader.float();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.spoofedDrones.push(SpoofDroneRequest.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofDroneCommand {
    return {
      durationS: isSet(object.durationS) ? globalThis.Number(object.durationS) : 0,
      spoofedDrones: globalThis.Array.isArray(object?.spoofedDrones)
        ? object.spoofedDrones.map((e: any) => SpoofDroneRequest.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SpoofDroneCommand): unknown {
    const obj: any = {};
    if (message.durationS !== 0) {
      obj.durationS = message.durationS;
    }
    if (message.spoofedDrones?.length) {
      obj.spoofedDrones = message.spoofedDrones.map((e) => SpoofDroneRequest.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofDroneCommand>, I>>(base?: I): SpoofDroneCommand {
    return SpoofDroneCommand.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofDroneCommand>, I>>(object: I): SpoofDroneCommand {
    const message = createBaseSpoofDroneCommand();
    message.durationS = object.durationS ?? 0;
    message.spoofedDrones = object.spoofedDrones?.map((e) => SpoofDroneRequest.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSpoofMultiDroneActionArgs(): SpoofMultiDroneActionArgs {
  return { trigger: undefined, spoofDroneCommands: [] };
}

export const SpoofMultiDroneActionArgs = {
  encode(message: SpoofMultiDroneActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.trigger !== undefined) {
      TriggerArgs_TimerCallback.encode(message.trigger, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.spoofDroneCommands) {
      SpoofDroneCommand.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofMultiDroneActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofMultiDroneActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trigger = TriggerArgs_TimerCallback.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.spoofDroneCommands.push(SpoofDroneCommand.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofMultiDroneActionArgs {
    return {
      trigger: isSet(object.trigger) ? TriggerArgs_TimerCallback.fromJSON(object.trigger) : undefined,
      spoofDroneCommands: globalThis.Array.isArray(object?.spoofDroneCommands)
        ? object.spoofDroneCommands.map((e: any) => SpoofDroneCommand.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SpoofMultiDroneActionArgs): unknown {
    const obj: any = {};
    if (message.trigger !== undefined) {
      obj.trigger = TriggerArgs_TimerCallback.toJSON(message.trigger);
    }
    if (message.spoofDroneCommands?.length) {
      obj.spoofDroneCommands = message.spoofDroneCommands.map((e) => SpoofDroneCommand.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofMultiDroneActionArgs>, I>>(base?: I): SpoofMultiDroneActionArgs {
    return SpoofMultiDroneActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofMultiDroneActionArgs>, I>>(object: I): SpoofMultiDroneActionArgs {
    const message = createBaseSpoofMultiDroneActionArgs();
    message.trigger = (object.trigger !== undefined && object.trigger !== null)
      ? TriggerArgs_TimerCallback.fromPartial(object.trigger)
      : undefined;
    message.spoofDroneCommands = object.spoofDroneCommands?.map((e) => SpoofDroneCommand.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
